/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Lakhoursuntillastschoolyear5Inputs */



/**

* @param {_Field_Lakhoursuntillastschoolyear5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_lakhoursuntillastschoolyear5 = /** @type {((inputs?: _Field_Lakhoursuntillastschoolyear5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Lakhoursuntillastschoolyear5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("LAK-Stunden bis Ende des letzten Schuljahres")
});
export { _field_lakhoursuntillastschoolyear5 as "_field_lakHoursUntilLastSchoolYear" }